<template>
    <div class="formulation-form-row">
        <div class="col-4 ">
            <select :disabled="viewMode" v-model="formVitamins[rowIndex].name" @change="onSelectElement($event)" class="form-control">
                <option class="d-none" value="">- Select -</option>
                <option value="none">Not Required</option>
                <option v-for="(item, index) in elementsList" :value="item.label" v-bind:key="index" :disabled="checkDisabled(item)">
                    {{item.label}}
                </option>
            </select>
            <button v-if="!viewMode && formVitamins.length > 1" class="list-item-remove" v-on:click="removeRow">Remove</button>
        </div>
        <div class="col-3" v-if="selectedItem">
            <input :disabled="viewMode" type="number" min="0" step="any" class="form-control" v-model="formVitamins[rowIndex].value" @input="onInputChanged" @keydown="$event.key === '-' ? $event.preventDefault() : null">
            <span class="form-uom">{{formVitamins[rowIndex].unit}}</span>
            <span class="form-error" v-if="error">Outside guidelines for stability</span>
        </div>
        <div class="col-5" v-if="selectedItem && formVitamins[rowIndex].value">
            <p v-if="getExtraMessage()" class="extra">{{getExtraMessage()}}</p>
        </div>
    </div>
</template>


<script>

// import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
    name: 'MicronutrientVitaminRow',
    components: {
    },
    props: {
        rowIndex: {
            required: true,
        },
        rowItem: {
            required: true,
        },
        elementsList: {
            required: true,
        },
        formVitamins: {
            required: true,
        },
        bagName: {
            required: true,
        },
        country: {
            required: true,
        },
        error: {
            required: false,
        },
        viewMode: {
            required: true,
        },
        selectedLipid: {
            required: true,
        },
    },
    data() {
        return {
            selectedItem: false,
        };
    },
    created() {
        this.setSelectedItem();
    },
    updated() {
        this.setSelectedItem();
    },
    methods: {
        setSelectedItem() {
            // this.selectedItem = false;
            if (this.rowItem.name) {
                const selectedItem = this.elementsList.find((item) => item.label === this.rowItem.name);
                this.selectedItem = selectedItem;
            }
        },
        onSelectElement(event) {
            const { value } = event.target;
            // search selected element
            const selectedItem = this.elementsList.find((item) => item.label === value);

            if (selectedItem) {
                this.selectedItem = selectedItem;
                this.formVitamins[this.rowIndex].unit = selectedItem.unit;
            } else {
                this.selectedItem = false;
                this.formVitamins[this.rowIndex].unit = false;
            }

            // reset value
            this.formVitamins[this.rowIndex].value = "";
            // reset error
            this.$emit('resetVitaminError', this.rowIndex);

            this.$emit('resetStability');
        },
        onInputChanged() {
            this.$emit('resetStability');
        },
        removeRow() {
            this.formVitamins.splice(this.rowIndex, 1);
            this.$emit('removeVitaminError', this.rowIndex);
            this.$emit('resetStability');
        },
        checkDisabled(item) {
            const vitaminsSubset = this.formVitamins.slice();
            vitaminsSubset.splice(this.rowIndex, 1);

            if (vitaminsSubset.find((el) => el.name === item.label)) {
                return true;
            }
            // custom cases
            const cernervit = vitaminsSubset.find((el) => el.name === 'Cernevit');
            if (cernervit) {
                if (item.label !== 'K') {
                    return true;
                }
            }
            const soluvit = vitaminsSubset.find((el) => el.name === 'Soluvit');
            if (soluvit) {
                if (item.label !== 'K' && item.label !== 'Vitalipid' && item.label !== 'Vitalipid Infant') {
                    return true;
                }
            }
            const vitalipid = vitaminsSubset.find((el) => el.name === 'Vitalipid' || el.name === 'Vitalipid Infant');
            if (vitalipid) {
                if (item.label !== 'K' && item.label !== 'Soluvit') {
                    return true;
                }
            }
            const k = vitaminsSubset.find((el) => el.name === 'K');
            if (k) {
                if (item.label !== 'Cernevit' && item.label !== 'Soluvit' && item.label !== 'Vitalipid' && item.label !== 'Vitalipid Infant') {
                    return true;
                }
            }
            // no vitalipid for Synthamin + fish lipid
            if (this.selectedLipid === 'Fish lipid' && (item.label === 'Vitalipid' || item.label === 'Vitalipid Infant')) {
                return true;
            }
            return false;
        },
        getExtraMessage() {
            let message = '';
            if (this.selectedItem.label === 'Cernevit' && this.selectedItem.extra) {
                let country = '';
                if (this.country === 'Australia') {
                    country = 'au';
                }
                if (this.country === 'New Zealand') {
                    country = 'nz';
                }
                if (country && this.selectedItem.extra[country]) {
                    const data = this.selectedItem.extra[country];
                    message = 'For stability purposes, ' + data.amount + data.unit + ' ' + data.label + ' will be added.';
                    if (data.sodium_contribution > 0) {
                        message += ' This will provide an extra ' + data.sodium_contribution + 'mmol Sodium to total amount in the bag';
                    }
                }
            }
            return message;
        },
    },
};
</script>
